import { formatPriceInput } from '@dashboard/services/formatting/price';

export default function prepareTicketTypePricingValues(values, currency) {
  if (values.pricing === 'free') {
    return { price: 0, discountedFromPrice: null, pwywSuggestedPrice: null };
  }

  const price = values.price ? formatPriceInput(values.price, currency) : 0;

  if (values.pricing === 'pwyw') {
    if (price < 0) {
      return { error: 'Minimum price must be 0 or more' };
    }

    const pwywSuggestedPrice = values.pwywSuggestedPrice
      ? formatPriceInput(values.pwywSuggestedPrice, currency)
      : null;

    if (pwywSuggestedPrice != null && pwywSuggestedPrice < price) {
      return { error: 'Suggested price must be at least the minimum price' };
    }

    return { price, discountedFromPrice: null, pwywSuggestedPrice };
  }

  // paid (labelled "Fixed price" in the UI)
  if (!price || price <= 0) {
    return { error: 'Price is required for fixed price tickets' };
  }

  const discountedFromPrice = values.discountedFromPrice
    ? formatPriceInput(values.discountedFromPrice, currency)
    : null;

  return { price, discountedFromPrice, pwywSuggestedPrice: null };
}
